export const TRIAL_WATERMARK = Object.freeze({
  logoPath: `${process.env.PUBLIC_URL || ''}/XLog3D Logo_Red.png`,
  footerUrl: 'xlog3d.dhawanacademy.com',
  badgeText: 'FREE TRIAL · LIMITED FEATURES',
  overlayText: 'FREE TRIAL · LIMITED FEATURES · XLOG3D-DHAWAN ACADEMY',
  opacity: 0.12,
});
